import { EuTaxonomyType } from '~/types/types'

export const EU_TAXONOMY_ICON_BY_TYPE: Record<EuTaxonomyType, string> = {
  [EuTaxonomyType.BiodiversityAndEcosystems]: 'biodiversity_and_ecosystems',
  [EuTaxonomyType.CircularEconomy]: 'circular_economy',
  [EuTaxonomyType.ClimateChangeAdaptation]: 'climate_change_adaptation',
  [EuTaxonomyType.ClimateChangeMitigation]: 'climate_change_mitigation',
  [EuTaxonomyType.PollutionPrevention]: 'pollution_prevention',
  [EuTaxonomyType.WaterAndMarineResources]: 'water_and_marine_resources',
}

export const EU_TAXONOMY_LABEL_KEY_BY_TYPE: Record<EuTaxonomyType, string> = {
  [EuTaxonomyType.BiodiversityAndEcosystems]:
    'impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.biodiversityAndEcosystems',
  [EuTaxonomyType.CircularEconomy]:
    'impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.circularEconomy',
  [EuTaxonomyType.ClimateChangeAdaptation]:
    'impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.climateChangeAdaptation',
  [EuTaxonomyType.ClimateChangeMitigation]:
    'impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.climateChangeMitigation',
  [EuTaxonomyType.PollutionPrevention]:
    'impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.pollutionPrevention',
  [EuTaxonomyType.WaterAndMarineResources]:
    'impactGoal.impacts.defineImpacts.classifyImpact.euTaxonomies.waterAndMarineResources',
}
